module.exports = __webpack_public_path__ + "static/media/automatedcontent_section2.d09ceff3.png";